import React from 'react'
import { shallow } from 'enzyme'

import Question from '../../features/Commentary/Question'
import Editor from '../../features/TextEditor/Editor'

describe('Question', () => {
  let wrapper, props, instance
  beforeEach(() => {
    props = {
      data: {
        administrator: {
          rid: 123,
          name: 'SmartBiz Admin',
        },
        rid: 10,
        category: 'closing',
        content: 'testing content',
        state: 'published',
        createdAt: '2019-12-02',
        document: {
          files: [
            {
              uuid: 'asdf;lkj',
              name: 'testing.pdf'
            }
          ],
          fileUrls: [
            {
              rid: 12345,
              filename: 'testing.pdf',
              link: '/admin/loans/testing.pdf'
            }
          ]
        },
        updatedAt: '2019-12-02',
        replies: [
          {
            administrator: {
              rid: 123,
              name: 'SmartBiz Admin',
            },
            rid: 3,
            draft: false,
            content: 'testing content',
          }
        ]
      },
      onCloseClick: () => {},
      onDeleteQuestion: () => {},
      onUpdateExisting: () => {},
      loanId: 123,
      isBankUser: false,
    },
    wrapper = shallow(<Question {...props} />)
    instance = wrapper.instance()
  })

  describe('#onShowRepliesClicked', () => {
    it('should change the state of showRepliesClicked', () => {
      instance.onShowRepliesClicked();
      expect(wrapper.state('showRepliesClicked')).toBeTruthy();
    })
  })
  describe('#getLastPublishedReply', () => {
    it('should return last published reply', () => {
      const lastReply = instance.getLastPublishedReply(props.data.replies)
      expect(lastReply.rid).toEqual(3);
    })
  })
  describe('#onQuestionEditClick', () => {
    it('should change states related to edit question workflow', () => {
      instance.onQuestionEditClick()
      expect(wrapper.state('editorState')).toEqual('open');
      expect(wrapper.state('optionClicked')).toEqual('edit');
      expect(wrapper.state('questionStatus')).toEqual('edit_question');
    })
  })
  describe('#onReplyClick', () => {
    it('should change states related to reply question workflow', () => {
      instance.onReplyClick()
      expect(wrapper.state('editorState')).toEqual('open');
      expect(wrapper.state('optionClicked')).toEqual('reply');
      expect(wrapper.state('questionStatus')).toEqual('reply_question');
    })
  })
  describe('#onQuestionDeleteClick', () => {
    it('should change states related to delete question workflow', () => {
      instance.onQuestionDeleteClick()
      expect(wrapper.state('editorState')).toEqual('closed')
    })
  })
  describe('#onQuestionStatusChange', () => {
    it('should change states from published to approve', () => {
      instance.onQuestionStatusChange()
      expect(wrapper.state('data').state).toEqual('approve')
      expect(wrapper.state('showRepliesClicked')).toBeFalsy();
    })
    it('should change states from approved to pending_approve', () => {
      props.data.state = 'approved'
      instance.onQuestionStatusChange()
      expect(wrapper.state('data').state).toEqual('pending_approve')
    })
  })
  describe('#showReplyButton', () => {
    it('should validate if reply button shold be shown or not', () => {
      const adminId = props.data.administrator.rid
      instance.showReplyButton(adminId, props.data.replies)
      expect(instance.showReplyButton(adminId, props.data.replies)).toBeFalsy();
    })
  })
  describe('#toggleState', () => {
    it('should change state', () => {
      expect(instance.toggleState('isHovered')).toBeFalsy();
      expect(wrapper.state('isHovered')).toBeTruthy();
    })
  })
  describe('#onSaveAsDraftClick', () => {
    it('should call function', () => {
      const onSaveAsDraftClick = spyOn(instance, 'onSaveAsDraftClick')
      instance.onSaveAsDraftClick('testing', null, null)
      expect(onSaveAsDraftClick).toHaveBeenCalled()
    })
  })

  describe('#onPostClick', () => {
    it('should call function', () => {
      const onPostClick = spyOn(instance, 'onPostClick')
      instance.onPostClick('testing', null, null)
      expect(onPostClick).toHaveBeenCalled()
    })
  })
  describe('#onCloseClick', () => {
    it('should call function', () => {
      instance.onCloseClick()
      expect(wrapper.state('editorState')).toEqual('closed')
    })
  })
  describe('#renderEditor', () => {
    describe('when optionClick is not reply', () => {
      it('should have fileUUID attribute the TextEditor', () => {
        wrapper.setState({editorState : 'open'})
        instance.renderEditor()
        const RichEditor = wrapper.find(Editor).at(0)
        const fileUUID = RichEditor.props().fileUUIDs
        expect(fileUUID.length).toEqual(1)
      })
    })
    describe('when optionClick is reply', () => {
      it('should not have fileUUID attribute the TextEditor', () => {
        wrapper.setState({ editorState: 'open', optionClicked: 'reply' })
        instance.renderEditor()
        const RichEditor = wrapper.find(Editor).at(0)
        const fileUUID = RichEditor.props().fileUUIDs
        expect(fileUUID.length).toEqual(0)
      })
    })
  })
})